const API =
  process.env.NODE_ENV === 'production'
    ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}/api`
    : `${window.location.protocol}//${window.location.hostname}:${process.env.REACT_APP_API_PORT}/api`;

export { API };
